export const ru = {
    'access-suggest-placeholder': 'Добавить пользователя или группу',
    'action-owner': 'Сделать владельцем',
    'action-remove': 'Удалить',
    'action-select-me': 'Добавить меня',
    active: 'Активно',
    address: 'Адрес страницы для перенаправления',
    'all-people-external': 'Всем сотрудникам',
    'all-people-hint-external': 'Страница доступна всем сотрудникам организации.',
    'all-people-hint-internal': 'Страница доступна всем штатным сотрудникам.',
    'all-people-internal': 'Всем штатным сотрудникам',
    author: 'Автор',
    'co-author': 'Соавтор',
    'comments-on-page': 'Комментарии на странице',
    'confirm-delete-cancel': 'Отмена',
    'confirm-delete-message': 'Вы собираетесь ограничить свой доступ к странице. После подтверждения вы не сможете просматривать и редактировать страницу.',
    'confirm-delete-save': 'Да, продолжить',
    'confirm-delete-title': 'Потеря доступа',
    departments: 'Подразделения',
    'dialog-apply': 'Сохранить',
    'dialog-cancel': 'Отменить',
    group: 'Группа',
    'hint-message': ' Вы можете перенаправить пользователей с этой страницы на другую',
    'hint-message-collab': 'Позволяет совместно редактировать страницу и видеть изменения коллег в реальном времени\n',
    'hint-message-redirect': 'Вы можете перенаправить пользователей с этой страницы на другую',
    'how-to-request-rights': 'Как запросить права',
    'incorrect-address-message': 'Чтобы увидеть полный адрес страницы, укажите корректное значение в поле «{{address}}».',
    'invalid-custom-acl-b2b': 'Если выбран тип доступа «Некоторым сотрудникам», укажите хотя бы одного пользователя (помимо авторов) или подразделение.',
    'invalid-custom-acl-intranet': 'Если выбран тип доступа «Некоторым сотрудникам», укажите хотя бы одного пользователя (помимо авторов), подразделение, сервис или группу.',
    'label-collab': 'Режим совместного редактирования',
    'like-parent': 'Как у родительской страницы',
    'new-address': 'Полный адрес перенаправления',
    'new-address-hint': 'Чтобы увидеть полный адрес, заполните поле «{{address}}».\'',
    'only-authors': 'Только авторам',
    'only-authors-hint': 'Только авторы могут редактировать страницу',
    owner: 'Владелец',
    'owner-tooltip': 'Этот пользователь отображается как автор над заголовком страницы.',
    'parent-access-hint-1': 'Страница доступна тем же людям, что и',
    'parent-access-hint-2': 'родительская страница.',
    placeholder: 'Имя или логин пользователя',
    'redirect-title': 'Перенаправление',
    'redirect-update-error': 'Некорректное значение в поле «Адрес страницы для перенаправления»',
    'request-author-role': 'Стать автором',
    'request-error': 'Ошибка при отправке запроса',
    'request-success': 'Запрос отправлен авторам страницы',
    'request-success-granted': 'Роль автора успешно выдана',
    'request-success-sent': 'Запрос уже был отправлен авторам страницы',
    save: 'Сохранить',
    'search-filters-section-current-page': 'текущий',
    services: 'Сервисы',
    'some-people': 'Некоторым сотрудникам',
    'tab-title-access': 'Права доступа',
    'tab-title-authors': 'Авторы',
    'tab-title-collab': 'Совместный режим',
    'tab-title-comments': 'Комментарии',
    'tab-title-common': 'Общие настройки',
    'tab-title-redirect': 'Перенаправление',
    teams: 'Команды',
    title: 'Настройки страницы',
    'update-error-general': 'Не удалось сохранить настройки доступа',
    'update-error-no-access-rights': 'У вас недостаточно прав, чтобы дать доступ к странице внештатным сотрудникам.',
    'update-settings-error-general': 'Не удалось сохранить настройки',
    'update-success': 'Настройки обновлены',
    'wiki-groups': 'Wiki-группы'
};
